// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apply box-sizing globally to prevent padding from increasing width */
* {
  box-sizing: border-box;
}

.teams-layout {
  display: flex;
  width: 100%;       /* Ensure full width */
  height: 100vh;     /* Use full viewport height or fit to container */
  overflow: hidden;  /* Prevent scrollbars on the main layout */
}

.teams-menu {
  width: 20%;        /* Target width */
  min-width: 200px;  /* Stop it from getting unreadably small */
  max-width: 300px;  /* Optional: Stop it from getting too big */
  flex-shrink: 0;    /* 👈 CRITICAL: Prevents the menu from being squashed by the table */
  
  border-right: 1px solid #ddd;
  padding: 1rem;
  background-color: #f9f9f9;
  height: 100%;      /* Fill parent height */
}

.teams-content {
  flex: 1 1;           /* Take up all remaining space */
  /* width: 80%;     <-- REMOVE THIS. flex: 1 handles the width automatically */
  
  padding: 1rem;
  background-color: #ffffff;
  margin: 0;         /* Clean up margins */
  height: 100%;      
  
  overflow-x: auto;  /* 👈 CRITICAL: If the table is wide, scroll INSIDE this box, don't stretch the layout */
  overflow-y: auto;  /* Allow vertical scrolling if needed */
}

/* ... Keep your existing Table Styles below ... */

.teams-title {
  font-size: 24px;
  font-weight: bold;
  color: #4caf50;
  margin-bottom: 20px;
}

.teams-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
}

.teams-header {
  text-align: left;
  background-color: #dff0d8;
  color: #333333;
  padding: 10px;
  font-weight: bold;
}

.teams-cell {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  color: #333333;
  text-align: left;
}

.teams-cell:hover {
  background-color: #f2f2f2;
  cursor: pointer;
}

.team-content-placeholder {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Team/Team.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW,QAAQ,sBAAsB;EACzC,aAAa,MAAM,iDAAiD;EACpE,gBAAgB,GAAG,0CAA0C;AAC/D;;AAEA;EACE,UAAU,SAAS,iBAAiB;EACpC,gBAAgB,GAAG,0CAA0C;EAC7D,gBAAgB,GAAG,2CAA2C;EAC9D,cAAc,KAAK,oEAAoE;;EAEvF,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,YAAY,OAAO,uBAAuB;AAC5C;;AAEA;EACE,SAAO,YAAY,gCAAgC;EACnD,6EAA6E;;EAE7E,aAAa;EACb,yBAAyB;EACzB,SAAS,UAAU,qBAAqB;EACxC,YAAY;;EAEZ,gBAAgB,GAAG,wFAAwF;EAC3G,gBAAgB,GAAG,uCAAuC;AAC5D;;AAEA,kDAAkD;;AAElD;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* Apply box-sizing globally to prevent padding from increasing width */\n* {\n  box-sizing: border-box;\n}\n\n.teams-layout {\n  display: flex;\n  width: 100%;       /* Ensure full width */\n  height: 100vh;     /* Use full viewport height or fit to container */\n  overflow: hidden;  /* Prevent scrollbars on the main layout */\n}\n\n.teams-menu {\n  width: 20%;        /* Target width */\n  min-width: 200px;  /* Stop it from getting unreadably small */\n  max-width: 300px;  /* Optional: Stop it from getting too big */\n  flex-shrink: 0;    /* 👈 CRITICAL: Prevents the menu from being squashed by the table */\n  \n  border-right: 1px solid #ddd;\n  padding: 1rem;\n  background-color: #f9f9f9;\n  height: 100%;      /* Fill parent height */\n}\n\n.teams-content {\n  flex: 1;           /* Take up all remaining space */\n  /* width: 80%;     <-- REMOVE THIS. flex: 1 handles the width automatically */\n  \n  padding: 1rem;\n  background-color: #ffffff;\n  margin: 0;         /* Clean up margins */\n  height: 100%;      \n  \n  overflow-x: auto;  /* 👈 CRITICAL: If the table is wide, scroll INSIDE this box, don't stretch the layout */\n  overflow-y: auto;  /* Allow vertical scrolling if needed */\n}\n\n/* ... Keep your existing Table Styles below ... */\n\n.teams-title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #4caf50;\n  margin-bottom: 20px;\n}\n\n.teams-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #ffffff;\n}\n\n.teams-header {\n  text-align: left;\n  background-color: #dff0d8;\n  color: #333333;\n  padding: 10px;\n  font-weight: bold;\n}\n\n.teams-cell {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n  color: #333333;\n  text-align: left;\n}\n\n.teams-cell:hover {\n  background-color: #f2f2f2;\n  cursor: pointer;\n}\n\n.team-content-placeholder {\n  font-size: 18px;\n  color: #666;\n  text-align: center;\n  margin-top: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
